import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "./sectionSevenThemeThree.css";

function SectionSevenThemeThree() {
  const navigate = useNavigate();
  const jsonData: any = useSelector<any>((state) => state.homeJsonList);
  const sliderRef = useRef<HTMLDivElement>(null);

  const section = jsonData?.theme_3?.home?.section_7;
  const rawCards = section?.card_section?.collection ?? [];
  // Swiper loop requires at least slidesPerView*2 slides; duplicate until we have enough
  const cards =
    rawCards.length > 0 && rawCards.length < 6
      ? [...rawCards, ...rawCards, ...rawCards]
      : rawCards;

  useEffect(() => {
    if (!sliderRef.current) return;
    const cardEls =
      sliderRef.current.querySelectorAll<HTMLElement>(".s7cate__card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 },
    );

    cardEls.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [rawCards.length]);

  return (
    <section className="s7cate">
      <div className="container">
        {/* ── header ── */}
        <div className="s7cate__head">
          <div className="s7cate__head-left">
            <span className="s7cate__eyebrow">Our Services</span>
            <h2
              className="s7cate__title"
              style={{
                color: section?.h2color ? `#${section.h2color}` : undefined,
              }}
            >
              {section?.title}
            </h2>
          </div>
          {section?.paragraph && (
            <p
              className="s7cate__para"
              style={{
                color: section?.paracolor ? `#${section.paracolor}` : undefined,
              }}
            >
              {section.paragraph}
            </p>
          )}
        </div>

        {/* ── slider ── */}
        <div ref={sliderRef}>
          <Swiper
            spaceBetween={16}
            slidesPerView={3}
            loop={true}
            navigation={true}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            modules={[Navigation, Autoplay]}
            breakpoints={{
              0: { slidesPerView: 1 },
              480: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
            }}
            className="s7cate__slider"
          >
            {cards.map((item: any, idx: number) => (
              <SwiperSlide key={idx}>
                <div className="s7cate__card">
                  <div className="s7cate__icon-wrap">
                    <img src={item.icon} alt={item.card_title} />
                  </div>
                  <h3
                    className="s7cate__card-title"
                  >
                    {item.card_title}
                  </h3>
                  <a
                    href="#"
                    className="s7cate__arrow"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/pricing");
                    }}
                    aria-label={`View ${item.card_title}`}
                  >
                    <i className="uil uil-arrow-right" />
                  </a>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default SectionSevenThemeThree;
